import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 21 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M7.125 3h6.75V1.125a1.124 1.124 0 1 1 2.25 0V3H18c1.655 0 3 1.343 3 3v15c0 1.655-1.345 3-3 3H3c-1.657 0-3-1.345-3-3V6a3 3 0 0 1 3-3h1.875V1.125a1.124 1.124 0 1 1 2.25 0zM2.25 21c0 .413.336.75.75.75h15c.413 0 .75-.337.75-.75V9H2.25z"
    }, null, -1)
  ]))]))
}
export default { render: render }